import './About.css'
function About(){
    return(
    <section id='about' className='about'>
    <h2 className='aboutme'>About me</h2>
    <p className='info'>I’m a passionate and self-driven full-stack developer from India who enjoys building meaningful and practical web applications. My journey into development started with curiosity and gradually turned into a strong commitment to learning by doing. I prefer working on real-world projects, which helps me understand concepts deeply and approach problems with a practical and solution-oriented mindset.</p>

<p className='info' >Alongside my technical skills, I’ve been consistently working on improving my communication and English fluency to become more confident in professional environments. I believe in discipline, continuous growth, and learning from every challenge I face. For me, progress comes from showing up every day and putting in focused effort.</p>

<p className='info'>My goal is to grow as a developer by working on impactful projects and expanding my expertise into areas like automation, AI, and cloud technologies. I aim to build a career where I can keep learning, adapt to new challenges, and create solutions that make a real difference.
</p>
    </section>
    )
}
export default About;